import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate, useParams } from "react-router-dom";
import ThreadForm from "../../components/forum/ThreadForm";
import ThreadListItem from "../../components/forum/ThreadListItem";
import React from "react";
import { TopicType, UserType } from "../../utils/types";
import { IconButton, Button } from "@mui/material";
import ReplyEditForm from "../../components/forum/ReplyEditForm";
import { getCSRFToken } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TopicEditForm from "../../components/forum/TopicEditForm";
import { ArrowBack } from "@mui/icons-material";

const Topic = () => {
  let { user } = useContext(AuthContext);
  const currentUser: UserType = user;
  // extract thread id
  const params = useParams();
  const topicID = params.id;

  // initalize thread and posts component state
  const [threads, setThreads] = useState([]);
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [topic, setTopic] = useState<TopicType>();
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);

  // trigger update depends on params of URL
  useEffect(() => {
    const getThreads = async () => {
      // fetch the threads from api endpoint
      const response = await fetch(`/api/threads/topic/${topicID}?page=1`);

      // parse the data in json
      let data = await response.json();

      // update the state of threads
      setThreads(data.results);

      // check if there is more threads
      if (data.next === null) {
        setHasMore(false);
      }
    };
    getThreads();
  }, [params]);

  useEffect(() => {
    const fetchTopics = async () => {
      const response = await fetch("/api/topics/");
      const data = await response.json();
      setTopic(data.find((topic) => topic.id?.toString() === topicID.trim()));
    };
    fetchTopics();
  }, [params]);
  const getMoreThreads = async () => {
    try {
      // fetch the threads from api endpoint
      const response = await fetch(
        `/api/threads/topic/${topicID}?page=${page}`
      );

      if (!response.ok) {
        return [];
      }

      // parse the data in json
      let data = await response.json();

      return data.results || [];
    } catch (err) {
      return [];
    }
  };

  const fetchData = async () => {
    // get more threads from next fetch
    const moreThreads = await getMoreThreads();

    // update the thread state by combining data
    setThreads([...threads, ...moreThreads]);

    // check the fetch of last page, if yes, HasMore is false
    if (moreThreads.length === 0 || moreThreads.length < 10) {
      setHasMore(false);
    }
    setPage(page + 1);
  };

  // style the paper component
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(),
    textAlign: "left",
    color: theme.palette.text.secondary,
  }));
  const navigate = useNavigate();

  return (
    <div style={{ marginTop: 100 }}>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12}>
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <Typography variant="h5"> {topic?.label} Beiträge</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    {topic?.creator}
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/forum")}
                    startIcon={<ArrowBack />}
                    style={{
                      maxWidth: "180px",
                      maxHeight: "32px",
                      minWidth: "100px",
                      minHeight: "32px",
                    }}
                  >
                    {window.innerWidth > 700 ? "Zurück" : ""}
                  </Button>
                  <ThreadForm />
                  <div>
                    {(currentUser?.id?.toString().trim() ===
                      topic?.creator_id?.toString().trim() ||
                      currentUser?.bemerkung === "GF") && (
                      <IconButton
                        aria-label="settings"
                        onClick={() => setSettingsMenuOpen(!settingsMenuOpen)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}
                    {settingsMenuOpen && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1,
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          padding: "10px",
                        }}
                      >
                        <TopicEditForm initialTopic={topic} />
                        <Button
                          variant="outlined"
                          onClick={async () => {
                            try {
                              const response = await fetch(`/api/topics/`, {
                                method: "DELETE",
                                headers: {
                                  "Content-Type": "application/json",
                                  "X-CSRFToken": getCSRFToken(),
                                },
                                body: JSON.stringify({
                                  id: topic.id,
                                }),
                              });

                              if (response.ok) {
                                navigate(`/forum`);
                              } else {
                                console.error("Failed to delete topic");
                              }
                            } catch (error) {
                              console.error("Error deleting topic:", error);
                            }
                          }}
                          style={{
                            maxWidth: "180px",
                            maxHeight: "32px",
                            minWidth: "100px",
                            minHeight: "32px",
                          }}
                        >
                          Löschen
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Item>
                <InfiniteScroll
                  dataLength={threads.length} //This is important field to render the next data
                  next={fetchData}
                  hasMore={hasMore}
                  loader={
                    <h4 style={{ textAlign: "center", marginTop: 20 }}>
                      Lädt...
                    </h4>
                  }
                  endMessage={
                    <p style={{ textAlign: "center", marginTop: 20 }}>
                      <span>Du hast alle Beiträge gesehen.</span>
                    </p>
                  }
                >
                  {threads.map((thread, index) => (
                    <ThreadListItem key={index} thread={thread} />
                  ))}
                </InfiniteScroll>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Topic;
